import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";

import { isEmpty } from "lodash";

export const LeftSideInfo = ({ boxesToLoad, upcomingBatches }) => {
  const { t } = useTranslation();

  return (
    <Row gutter={[0, 24]}>
      <Col span={24}>
        <div className="dm-fs-heading to-be-loaded">
          <div className="dm-fs-title uppercase">{t("label.toBeLoaded")}</div>
          <div className="dm-fs-title uppercase">{t("label.boxCode")}</div>
        </div>
        <div className="dm-fs-left-container">
          {!isEmpty(boxesToLoad) ? (
            <div className="dfs-tc-container">
              {boxesToLoad?.map((location) => {
                return (
                  <div
                    className="dfs-tcc-row tbl-container"
                    key={location?._id}
                  >
                    <div className="dfs-tcr-name">{location?.name}</div>
                    <div className="dfs-tcr-list">
                      {location.boxList.map((b, bIndex) => (
                        <div className="dfs-tcr-box" key={bIndex}>
                          {b}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <span>{t("txt.noBoxes")}</span>
          )}
        </div>
      </Col>
      <Col span={24}>
        <div className="dm-fs-heading upcoming-batches">
          <div className="dm-fs-title uppercase">
            {t("label.upcomingBatches")}
          </div>
          <div className="dm-fs-title uppercase">{t("label.noOfBatches")}</div>
        </div>
        <div className="dm-fs-left-container">
          {!isEmpty(upcomingBatches) ? (
            <div className="dfs-tc-container">
              {upcomingBatches?.map((location) => {
                return (
                  <div className="dfs-tcc-row ub-container" key={location?._id}>
                    <div className="dfs-tcr-name">{location?.name}</div>
                    <div className="dfs-tcr-box">{location.count}</div>
                  </div>
                );
              })}
            </div>
          ) : (
            <span>{t("txt.noBatches")}</span>
          )}
        </div>
      </Col>
    </Row>
  );
};

export const MainContent = ({ trolleyArray }) => {
  const { t } = useTranslation();

  const TrolleyContainer = ({ trolley }) => {
    const trolleyName = trolley.trolley?.name || trolley.trolley?.code;
    return (
      <Col span={24} xl={8}>
        <div className="dm-fs-container">
          <Row>
            <Col span={24} className="dm-fs-inner-heading">
              <Row gutter={[0, 8]}>
                <Col span={24}>
                  <div className="dm-fs-title">{trolleyName}</div>
                </Col>
                <Col span={24}>
                  <div className="dm-fs-subtitle">
                    <span className="dm-fs-subtitle-status">
                      {t("label.boxes")}: {`${trolley?.noOfBoxes ?? "0"}`}
                    </span>
                    <span className="dm-fs-subtitle-status">
                      {t("label.loose")}:{" "}
                      {`${trolley?.noOfLooseParcels ?? "0"}`}
                    </span>
                    <span className="dm-fs-subtitle-status">
                      {t("label.bulk")}: {`${trolley?.noOfBulkParcels ?? "0"}`}
                    </span>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col span={24} className="dm-fs-content">
              <Row>
                {trolley?.boxParcelListData?.map((boxData: any) => (
                  <Col key={boxData._id} span={24}>
                    {boxData?.box?.name || boxData?.box?.code || "-"}
                  </Col>
                ))}
                {trolley?.parcelListData?.map((parcel, index) => (
                  <Col key={parcel._id} span={24}>
                    <div className="dm-fs-parcel-container">
                      <div>{parcel?.trackingNumber}</div>
                      <div className="dm-fs-type">
                        {parcel?.looseOrders
                          ? t("label.loose")
                          : t("label.bulk")}
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </div>
      </Col>
    );
  };

  const NoTrolleyLoaded = () => {
    return <div>{t("txt.noTrolleysLoaded")}</div>;
  };

  return (
    <Row>
      <Col span={24}>
        <div className="dm-fs-heading">
          <div className="dm-fs-title uppercase">{t("label.trolleys")}</div>
        </div>
      </Col>
      <Col span={24}>
        <Row gutter={[16, 16]}>
          {!isEmpty(trolleyArray) ? (
            trolleyArray.map((trolley, index) => (
              <React.Fragment key={index}>
                <TrolleyContainer trolley={trolley} />
              </React.Fragment>
            ))
          ) : (
            <NoTrolleyLoaded />
          )}
        </Row>
      </Col>
    </Row>
  );
};
